import React from 'react';
import profileImg from '../assets/img/Profile1.jpg';

const About = () => {
  return (
    <section id="about" className="about section">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>About</h2>
        <p>
          I am Muhammad Jahanzaib Iqbal, a Software Engineer specializing in cross-platform mobile application development with Flutter &amp; Dart, 
          BLE hardware integration, and scalable backend services. With published applications on Google Play, I engineer end-to-end solutions—from 
          smart vending IoT systems and AI coding platforms to robust RESTful backends with Django, Supabase, and Firebase.
        </p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row gy-4 align-items-center justify-content-center">
          <div className="col-lg-4 text-center">
            <div className="about-img-wrap">
              <img src={profileImg} className="img-fluid" alt="Muhammad Jahanzaib Iqbal" />
            </div>
          </div>
          <div className="col-lg-8 content">
            <h2>SOFTWARE ENGINEER</h2>
            <h3 style={{ fontSize: '1.2rem', color: '#2563eb', fontWeight: '700', marginTop: '6px' }}>
              FLUTTER &amp; MOBILE APPLICATION ENGINEER
            </h3>
            <p className="fst-italic py-3">
              Results-driven Mobile Application Engineer with demonstrated expertise in shipping production-grade Flutter apps, 
              hardware-to-mobile communication via Bluetooth Low Energy (BLE), secure payment gateway integrations (Moyasar), and 
              scalable backend architectures. Dedicated to clean code, responsive design, and intuitive user experiences.
            </p>
            <div className="row">
              <div className="col-md-6">
                <ul>
                  <li><i className="bi bi-chevron-right"></i> <strong>University:</strong> <span>COMSATS University, Lahore</span></li>
                  <li><i className="bi bi-chevron-right"></i> <strong>Phone:</strong> <span><a href="tel:+923021164516">+92 302 1164516</a></span></li>
                  <li><i className="bi bi-chevron-right"></i> <strong>City:</strong> <span>Lahore, Punjab, Pakistan</span></li>
                </ul>
              </div>
              <div className="col-md-6">
                <ul>
                  <li><i className="bi bi-chevron-right"></i> <strong>Degree:</strong> <span>BS Software Engineering</span></li>
                  <li><i className="bi bi-chevron-right"></i> <strong>Email:</strong> <span><a href="mailto:jahanzaibiqbal150@gmail.com">jahanzaibiqbal150@gmail.com</a></span></li>
                  <li><i className="bi bi-chevron-right"></i> <strong>LinkedIn:</strong> <span><a href="https://www.linkedin.com/in/muhammad-jahanzaib-iqbal-64a994292/" target="_blank" rel="noopener noreferrer">View Profile</a></span></li>
                </ul>
              </div>
            </div>
            <p className="py-3">
              Beyond core software engineering, I focus on building real-world products that solve tangible problems. From architecting 
              Bluetooth Low Energy (BLE) vending machine controllers and digital payment systems to engineering multi-language mobile IDEs 
              with AI assistance, I bring high standards of code craftsmanship, strong analytical problem-solving, and continuous curiosity 
              to every project.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
